import "./string";
import { Animations } from "../helpers/animations";
HTMLElement.prototype.closest = function (selector) {
    let result = null;
    for (let element = this; element && element.nodeType == 1; element = element.parentElement || element.parentNode) {
        if (element.matches(selector))
            return element;
    }
    return null;
};
HTMLElement.prototype.empty = function () {
    while (this.firstChild) {
        this.removeChild(this.firstChild);
    }
};
HTMLElement.prototype.visible = function (show) {
    if (show != null) {
        if (show == true)
            this.addStyles({ "display": "block" });
        else
            this.addStyles({ "display": "none" });
    }
    return !!(this.offsetWidth || this.offsetHeight || this.getClientRects().length);
};
HTMLElement.prototype.getClasses = function () {
    let attrstr = this.getAttribute("class");
    return attrstr != null ? attrstr.split(" ") : [];
};
HTMLElement.prototype.hasClass = function (name) {
    let attrstr = this.getAttribute("class");
    return attrstr.indexOf(name) > -1;
};
HTMLElement.prototype.addClass = function (name) {
    let attrs = this.getClasses();
    if (attrs.indexOf(name) > -1)
        return this;
    attrs.push(name);
    this.setAttribute("class", attrs.join(" "));
    return this;
};
HTMLElement.prototype.removeClass = function (name) {
    let attrs = this.getClasses();
    let index = attrs.indexOf(name);
    if (index == -1)
        return this;
    attrs.splice(index, 1);
    this.setAttribute("class", attrs.join(" "));
    return this;
};
HTMLElement.prototype.toggleClass = function (name) {
    if (this.hasClass(name)) {
        this.removeClass(name);
        return this;
    }
    this.addClass(name);
    return this;
};
HTMLElement.prototype.getStyles = function () {
    let styles = this.getAttribute("style");
    return this.parseStyles(styles);
};
HTMLElement.prototype.parseStyles = function (styles) {
    let output = {};
    if (String.isNullOrEmpty(styles))
        return output;
    let stylesArr = styles.split(";");
    for (let i = 0; i < stylesArr.length; i++) {
        let temp = stylesArr[i].split(":");
        if (temp.length <= 1)
            continue;
        let name = temp[0].trimChar(" ");
        let value = temp[1].trimChar(" ");
        output[name] = value;
    }
    return output;
};
HTMLElement.prototype.hasStyle = function (style) {
    let attrstr = this.getAttribute("style");
    return attrstr.indexOf(style + ";") > -1;
};
HTMLElement.prototype.hasStyles = function (styles) {
    let oldStyles = this.getStyles();
    for (let prop in styles) {
        if (!oldStyles.hasOwnProperty(prop)) {
            return false;
        }
    }
    return true;
};
HTMLElement.prototype.addStyle = function (style, value) {
    let newStyles = {};
    newStyles[style] = value;
    return this.addStyles(newStyles);
};
HTMLElement.prototype.addStyles = function (styles) {
    let oldStyles = this.getStyles();
    let mergedStyles = Object.merge(oldStyles, styles);
    let stylesStr = "";
    for (let prop in mergedStyles) {
        if (mergedStyles[prop] != "") {
            stylesStr += String.format("{0}: {1};", prop, mergedStyles[prop]);
        }
    }
    this.setAttribute("style", stylesStr);
    return this;
};
HTMLElement.prototype.removeStyle = function (style) {
    let newStyles = {};
    newStyles[style] = "";
    return this.addStyles(newStyles);
};
HTMLElement.prototype.removeStyles = function (styles) {
    for (let prop in styles) {
        styles[prop] = "";
    }
    return this.addStyles(styles);
};
HTMLElement.prototype.toggleStyle = function (style, value) {
    let newStyles = {};
    newStyles[style] = value;
    return this.toggleStyles(newStyles);
};
HTMLElement.prototype.toggleStyles = function (styles) {
    let oldStyles = this.getStyles();
    let remove = false;
    for (let prop in styles) {
        if (oldStyles.hasOwnProperty(prop)) {
            remove = true;
            break;
        }
    }
    if (remove) {
        return this.removeStyles(styles);
    }
    return this.addStyles(styles);
};
HTMLElement.prototype.setData = function (key, value) {
    this.setAttribute("data-" + key, value);
    return this;
};
HTMLElement.prototype.getData = function (key) {
    let regex = /data-([^=]+)=["|']([^"|']*)["|']/g;
    if (key) {
        regex = new RegExp("data-(" + key + ")=[\"|']([^\"|']*)[\"|']", "g");
    }
    const str = this.outerHTML;
    let match;
    let output = {};
    while ((match = regex.exec(str)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (match.index === regex.lastIndex) {
            regex.lastIndex++;
        }
        output[match[1]] = match[2];
    }
    return output;
};
HTMLElement.prototype.slideToggle = function (duration, easing) {
    Animations.slideToggle(this, duration, easing);
};
HTMLElement.prototype.slideUp = function (duration, easing) {
    Animations.slideUp(this, duration, easing);
};
HTMLElement.prototype.slideDown = function (duration, easing) {
    Animations.slideDown(this, duration, easing);
};
HTMLElement.prototype.inView = function (options) {
    if (!options)
        options = { offset: { top: 0, right: 0, bottom: 0, left: 0 }, threshold: 0 };
    const { top, right, bottom, left, width, height } = this.getBoundingClientRect();
    const intersection = {
        t: bottom,
        r: window.innerWidth - left,
        b: window.innerHeight - top,
        l: right
    };
    const threshold = {
        x: options.threshold * width,
        y: options.threshold * height
    };
    return intersection.t > (options.offset.top + threshold.y)
        && intersection.r > (options.offset.right + threshold.x)
        && intersection.b > (options.offset.bottom + threshold.y)
        && intersection.l > (options.offset.left + threshold.x);
};
